export function doesTourPaymentScheduleTemplateMatchLeadTime(
  paymentScheduleTemplate: App.Tours.TourPaymentScheduleTemplate,
  daysTillDeparture: number,
): boolean {
  const { leadTimeRange, minimumLeadDays } = paymentScheduleTemplate

  if (!leadTimeRange) {
    return daysTillDeparture >= minimumLeadDays
  }

  if (daysTillDeparture < leadTimeRange.minDays) {
    return false
  }

  if (leadTimeRange.maxDays !== undefined && daysTillDeparture > leadTimeRange.maxDays) {
    return false
  }

  return true
}

/**
 * A lone template matches on `minimumLeadDays` only — checkout sends it as a bare
 * `templateId`, which svc-payment validates that way. Multiple templates match on
 * `leadTimeRange` bands (checkout sends `templateIds`).
 */
export default function getMatchingTourPaymentScheduleTemplate(
  paymentScheduleTemplates: Array<App.Tours.TourPaymentScheduleTemplate> | undefined,
  daysTillDeparture: number,
): App.Tours.TourPaymentScheduleTemplate | undefined {
  if (!paymentScheduleTemplates?.length) return undefined

  if (paymentScheduleTemplates.length === 1) {
    const [paymentScheduleTemplate] = paymentScheduleTemplates
    return daysTillDeparture >= paymentScheduleTemplate.minimumLeadDays
      ? paymentScheduleTemplate
      : undefined
  }

  return paymentScheduleTemplates.find((paymentScheduleTemplate) => {
    return doesTourPaymentScheduleTemplateMatchLeadTime(paymentScheduleTemplate, daysTillDeparture)
  })
}
